/* shto-scp-coll: Santa Cruz Paleo Collections page (sections/shto-scp-coll-main.liquid).
   - Best selling by default: the section's inline script already asked Shopify for this section with sort_by=best-selling
     (Section Rendering API). Here the answer replaces the section before the grid is shown. Address unchanged.
   - Tabs: sideways scroll with arrows, fades and a progress line when they don't fit.
   - Load more / Filters: every product of the collection is already in the page in the chosen order; these only show/hide.
   - Add to cart: /cart/add.js (the store's own Klaviyo add-to-cart listener sees it), then the Shto cart drawer opens. */
(() => {
  const R = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function rule(card, r) {
    const title = card.dataset.title || '';
    const type = card.dataset.type || '';
    const handle = card.dataset.handle || '';
    const toks = r.split(',').map((t) => t.trim()).filter(Boolean);
    const inc = toks.filter((t) => t[0] !== '-');
    const exc = toks.filter((t) => t[0] === '-').map((t) => t.slice(1).trim());
    if (exc.some((t) => title.includes(t))) return false;
    return inc.some((t) => {
      if (t.startsWith('type:')) return type === t.slice(5).trim();
      if (t.startsWith('handle:')) return handle.includes(t.slice(7).trim());
      if (t[0] === '^') return title.startsWith(t.slice(1).trim());
      return title.includes(t);
    });
  }

  function init(root) {
    if (!root || root.dataset.shtoReady) return;
    root.dataset.shtoReady = '1';
    const perPage = Number(root.dataset.perPage) || 12;
    const showingTpl = root.dataset.showing || '';
    const filtersLabel = root.dataset.filtersLabel || 'Filters';
    const cards = [...root.querySelectorAll('[data-shto-coll-card]')];
    let limit = perPage;

    /* ---- grid: filters + load more ---- */
    const groups = [...root.querySelectorAll('[data-shto-coll-filter-group]')];
    const activeRules = () => groups.map((g) => [...g.querySelectorAll('input:checked')].map((i) => i.dataset.rule)).filter((a) => a.length);
    function matches(card, rules) { return rules.every((list) => list.some((r) => rule(card, r))); }
    function paint() {
      const rules = activeRules();
      const pool = cards.filter((c) => matches(c, rules));
      cards.forEach((c) => { c.hidden = true; });
      pool.slice(0, limit).forEach((c) => { c.hidden = false; });
      const shown = Math.min(limit, pool.length);
      const t = root.querySelector('[data-shto-coll-showing]');
      if (t) t.textContent = showingTpl.replace('[shown]', shown).replace('[total]', pool.length);
      const f = root.querySelector('[data-shto-coll-fill]');
      if (f) f.style.width = pool.length ? `${(shown / pool.length) * 100}%` : '0%';
      const more = root.querySelector('[data-shto-coll-more]');
      if (more) more.hidden = shown >= pool.length;
      const none = root.querySelector('[data-shto-coll-nomatch]');
      if (none) none.hidden = pool.length > 0 || !cards.length;
      const wrap = root.querySelector('.shto-scp-coll-more');
      if (wrap) wrap.hidden = pool.length === 0;
      const n = rules.reduce((a, l) => a + l.length, 0);
      root.querySelectorAll('[data-shto-coll-filter-count]').forEach((el) => { el.textContent = `${filtersLabel} (${n})`; });
      root.querySelector('[data-shto-coll-filter-toggle]')?.classList.toggle('has-active', n > 0);
    }
    root.querySelector('[data-shto-coll-more]')?.addEventListener('click', () => {
      const first = cards.filter((c) => c.hidden && matches(c, activeRules()))[0];
      limit += perPage;
      paint();
      if (first) { const a = first.querySelector('a[href]'); a && a.focus({ preventScroll: true }); }
    });

    /* ---- filter panel ---- */
    const isDesk = () => window.matchMedia('(min-width: 990px)').matches;
    const fToggle = root.querySelector('[data-shto-coll-filter-toggle]');
    const fPanel = root.querySelector('[data-shto-coll-filter-panel]');
    let snapshot = null;
    function openFilters() {
      snapshot = [...fPanel.querySelectorAll('input')].map((i) => i.checked);
      fPanel.hidden = false; fToggle.setAttribute('aria-expanded', 'true');
      if (!isDesk()) { document.documentElement.classList.add('shto-coll-lock'); fPanel.setAttribute('aria-modal', 'true'); fPanel.querySelector('[data-shto-coll-filter-close]')?.focus(); }
      closeSort();
    }
    function closeFilters(apply) {
      if (!fPanel || fPanel.hidden) return;
      if (!apply && !isDesk() && snapshot) fPanel.querySelectorAll('input').forEach((i, k) => { i.checked = snapshot[k]; });
      fPanel.hidden = true; fToggle.setAttribute('aria-expanded', 'false'); fPanel.setAttribute('aria-modal', 'false');
      document.documentElement.classList.remove('shto-coll-lock');
      limit = perPage; paint();
    }
    if (fToggle && fPanel) {
      fToggle.addEventListener('click', () => (fPanel.hidden ? openFilters() : closeFilters(true)));
      fPanel.addEventListener('change', () => { if (isDesk()) { limit = perPage; paint(); } });
      root.querySelector('[data-shto-coll-filter-close]')?.addEventListener('click', () => { closeFilters(false); fToggle.focus(); });
      root.querySelector('[data-shto-coll-filter-apply]')?.addEventListener('click', () => { closeFilters(true); fToggle.focus(); });
      root.querySelector('[data-shto-coll-filter-reset]')?.addEventListener('click', () => { fPanel.querySelectorAll('input').forEach((i) => { i.checked = false; }); if (isDesk()) paint(); });
    }

    /* ---- sort ---- */
    const sToggle = root.querySelector('[data-shto-coll-sort-toggle]');
    const sList = root.querySelector('[data-shto-coll-sort-list]');
    function closeSort() { if (sList && !sList.hidden) { sList.hidden = true; sToggle.setAttribute('aria-expanded', 'false'); } }
    sToggle?.addEventListener('click', () => {
      if (sList.hidden) { closeFilters(true); sList.hidden = false; sToggle.setAttribute('aria-expanded', 'true'); } else closeSort();
    });

    document.addEventListener('click', (e) => {
      if (!root.isConnected) return;
      if (sList && !sList.hidden && !e.target.closest('.shto-scp-coll-sort')) closeSort();
      if (fPanel && !fPanel.hidden && isDesk() && !e.target.closest('.shto-scp-coll-filter')) closeFilters(true);
    });
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape' || !root.isConnected) return;
      if (sList && !sList.hidden) { closeSort(); sToggle.focus(); }
      if (fPanel && !fPanel.hidden) { closeFilters(isDesk()); fToggle.focus(); }
    });

    /* ---- tabs ---- */
    const vp = root.querySelector('[data-shto-coll-tabs]');
    const row = root.querySelector('[data-shto-coll-tabs-row]');
    const prev = root.querySelector('[data-shto-coll-tabs-prev]');
    const next = root.querySelector('[data-shto-coll-tabs-next]');
    const thumb = root.querySelector('[data-shto-coll-tabs-thumb]');
    function tabsUpdate() {
      if (!row) return;
      const max = row.scrollWidth - row.clientWidth;
      const over = max > 1;
      vp.toggleAttribute('data-overflow', over);
      const canPrev = over && row.scrollLeft > 1;
      const canNext = over && row.scrollLeft < max - 1;
      vp.toggleAttribute('data-can-prev', canPrev); vp.toggleAttribute('data-can-next', canNext);
      prev.hidden = !canPrev; next.hidden = !canNext;
      if (thumb && over) {
        const track = thumb.parentElement.clientWidth;
        const w = Math.max(24, track * (row.clientWidth / row.scrollWidth));
        thumb.style.width = `${w}px`;
        thumb.style.setProperty('--thumb-x', `${(track - w) * (row.scrollLeft / max)}px`);
      }
    }
    if (row) {
      row.addEventListener('scroll', tabsUpdate, { passive: true });
      window.addEventListener('resize', tabsUpdate);
      const step = (dir) => row.scrollBy({ left: dir * row.clientWidth * 0.7, behavior: 'smooth' });
      prev.addEventListener('click', () => step(-1));
      next.addEventListener('click', () => step(1));
      const act = row.querySelector('.is-active');
      if (act && act.offsetLeft + act.offsetWidth > row.clientWidth) row.scrollLeft = act.offsetLeft - 16;
      tabsUpdate();
      if (document.fonts) document.fonts.ready.then(tabsUpdate);
    }

    /* ---- add to cart ---- */
    root.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-shto-coll-add]');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      btn.setAttribute('data-busy', ''); btn.disabled = true;
      const span = btn.querySelector('span');
      const was = span ? span.textContent : '';
      try {
        const res = await fetch(`${R}cart/add.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(btn.dataset.shtoCollAdd), quantity: 1 }] })
        });
        const json = await res.json().catch(() => ({}));
        if (!res.ok || json.status) throw new Error(json.description || json.message || 'Error');
        if (window.ShtoScpCart) { window.ShtoScpCart.open(); window.ShtoScpCart.refresh(); }
        else { const d = document.getElementById('Cart-Drawer'); if (d && typeof d.open === 'function') { document.dispatchEvent(new CustomEvent('cart:refresh')); d.open(); } else window.location.href = `${R}cart`; }
      } catch (err) {
        if (span) { span.textContent = err.message.length < 24 ? err.message : '!'; setTimeout(() => { span.textContent = was; }, 2500); }
      } finally {
        btn.removeAttribute('data-busy'); btn.disabled = false;
      }
    });

    paint();
  }

  function boot() {
    const resort = window.ShtoCollResort;
    const root = document.querySelector('[data-shto-coll]');
    if (resort && root && !resort.done) {
      resort.done = true;
      resort.req.then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-shto-coll]');
        if (fresh) root.replaceWith(document.importNode(fresh, true));
      }).catch(() => {}).finally(() => {
        document.documentElement.classList.remove('shto-coll-resorting');
        document.querySelectorAll('[data-shto-coll]').forEach(init);
      });
      return;
    }
    document.querySelectorAll('[data-shto-coll]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', () => document.querySelectorAll('[data-shto-coll]').forEach(init));
})();
